<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-input
        size="medium"
        v-model="searchForm.nodeName"
        placeholder="请输入节点名称"
        @keyup.enter.native="getTableList"
      ></el-input>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">查询</el-button>
      <span class="txt_1">当前分币类型：<span class="txt_2">{{incomeSettingsData&&incomeSettingsData.open=='true'?'全网收益分币':'节点收益分币'}}</span></span>
      <span class="txt_1">全网平均单T Burn： <span class="txt_2">{{incomeSettingsData&&incomeSettingsData.unitBurn?incomeSettingsData.unitBurn + 'FIL':0}}</span></span>
      <span class="txt_1" style="padding-right:50px">全网平均单T Gas：<span class="txt_2">{{incomeSettingsData&&incomeSettingsData.unitGas?incomeSettingsData.unitGas + 'FIL':0}}</span></span>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="openSet()">设置</el-button>
      <!-- <div v-if="incomeSettingsData">
       
      </div> -->
    </div>
    <div class="searchRight">
      <el-button size="medium" type="primary" icon="el-icon-plus" @click="addFunc">增加</el-button>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      prop="nodeNumber"
      label="节点编号">
    </el-table-column>
    <el-table-column
      prop="nodeName"
      label="节点名称">
    </el-table-column>
    <el-table-column
      prop="maxPower"
      label="全部算力">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.maxPower,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="soldPower"
      label="已销售算力">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.soldPower,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="beSalePower"
      label="待销售算力">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.beSalePower,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="是否封装">
      <template slot-scope="scope">
        <div>
          <el-switch
          @change="ChangeTypeIsDel(scope.row)"
          v-model="scope.row.isDelCheck"
          active-color="#67c23a"
          inactive-color="#999">
          </el-switch>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      label="是否销售">
      <template slot-scope="scope">
        <div>
          <el-switch
          @change="ChangeTypeIsDel(scope.row)"
          v-model="scope.row.isSellCheck"
          active-color="#67c23a"
          inactive-color="#999">
          </el-switch>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      label="自动分币">
      <template slot-scope="scope">
        <div>
          <el-switch
          @change="ChangeTypeIsDel(scope.row)"
          v-model="scope.row.isAutoAllocate"
          active-color="#67c23a"
          inactive-color="#999">
          </el-switch>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="createTime"
      label="昨日收益分币状态">
      <template slot-scope="scope">
        <span>{{scope.row.yesterdayIncomeAllocateStatus==1?'待分币':scope.row.yesterdayIncomeAllocateStatus==2?'分币中':'已分币'}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="createTime"
      width="160"
      label="创建时间">
      <template slot-scope="scope">
        <span>{{$selfFunc.dayjsFunc(scope.row.createTime)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      fixed="right"
      width="180px"
      label="操作">
      <template slot-scope="scope" >
        <el-button size="mini" type="primary" @click="goDetaill(scope.row)"><i class="el-icon-view" style="margin-right:3px;"></i>查看详情</el-button>
        <el-button size="mini" type="primary" @click="getCent(scope.row)"><i class="el-icon-view" style="margin-right:3px;"></i>分币</el-button>
      </template>
    </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.page"
      :page-sizes="[20, 50, 100, 500]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
    >
    </el-pagination>
  </div>
    <el-dialog
      title="新增节点"
      :visible.sync="dialogVisible"
      width="450px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="132px" class="demo-ruleForm">
          <el-form-item label="节点编号" prop="nodeNumber">
            <el-input placeholder="请输入节点编号" v-model="ruleForm.nodeNumber" style="width:220px" type="text" ></el-input>
          </el-form-item>
          <el-form-item label="节点名称" prop="nodeName">
            <el-input placeholder="请输入节点名称" v-model="ruleForm.nodeName" style="width:220px" type="text"></el-input>
          </el-form-item>
          <el-form-item label="节点说明" prop="notes">
            <el-input placeholder="请输入节点说明" v-model="ruleForm.notes" style="width:220px" type="textarea"></el-input>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="节点详情"
      :visible.sync="dialogVisibleTwo"
      width="600px" class="module_tow">
      <div class="tow_box">
        <div class="saml_box">
          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <span>节点编号：</span>
                <span>{{detaillData.nodeNumber}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <span>节点名称：</span>
                <span>{{detaillData.nodeName}}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="saml_box">
          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <span>创建时间：</span>
                <span>{{$selfFunc.dayjsFunc(detaillData.createTime)}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <span>有效算力：</span>
                <span>{{detaillData.availablePower}} TiB</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="saml_box">
          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <span>已销售算力：</span>
                <span>{{detaillData.soldPower}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <span>待销售算力：</span>
                <span>{{detaillData.beSalePower}}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="saml_box">
          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <span>用于封装：</span>
                <span>{{detaillData.isPackage==1?'是':'否'}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <span>用于现货销售：</span>
                <span>{{detaillData.isSell==1?'是':'否'}}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="decBox">
          <div class="dec_title">节点说明</div>
          <div >{{detaillData.notes}}</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="设置"
      :visible.sync="dialogVisibleThr"
      width="450px">
      <el-form :model="ruleFormTwo" :rules="rules" ref="ruleFormTwo" label-width="140px" class="demo-ruleForm">
        <el-form-item label="分币类型" prop="open">
          <el-select size="medium" clearable v-model="ruleFormTwo.open"  placeholder="请选择分币类型" style="width:220px">
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="全网平均单T Burn" prop="unitBurn">
          <el-input placeholder="请输入全网平均单T Burn" v-model="ruleFormTwo.unitBurn" style="width:220px" type="number" ></el-input>
        </el-form-item>
        <el-form-item label="全网平均单T Gas" prop="unitGas">
          <el-input placeholder="请输入全网平均单T Gas" v-model="ruleFormTwo.unitGas" style="width:220px" type="number" ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleThr = false">取 消</el-button>
          <el-button type="primary" @click="submitFormTwo('ruleFormTwo')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:20,
        nodeName: ''
      },
      
      options: [
        {
          name: '全部',
          value: ''
        },
        {
          name: '待封装',
          value: '2'
        },
        {
          name: '已完成',
          value: '1'
        },
        // {
        //   name: '已取消',
        //   value: '3'
        // }
      ],
      tableData: [],
      dialogVisible:false,
      dialogVisibleTwo: false,
      dialogVisibleThr: false,
      detaillData: {},
      incomeSettingsData: {},
      typeList: [
        {value: 1, name: '全网收益分币'},
        {value: 2, name: '节点收益分币'}
      ],
      // mineNumberNo: '',
      ruleForm:{
        notes: '',
        nodeNumber: '',
        nodeName: ''
      },
      ruleFormTwo: {
        open: null,
        unitBurn: null,
        unitGas: null
      },
      rules:{
        nodeNumber: [
          { required: true, message: '请输入节点编号', trigger: 'blur' },
        ],
        nodeName:[
            { required: true, message: '请输入节点名称', trigger: 'blur' }
        ],
        open: [
          { required: true, message: '请选择分币类型', trigger: 'change' }
        ],
        unitBurn: [
          { required: true, message: '请输入节点编号', trigger: 'blur' },
        ],
        unitGas: [
          { required: true, message: '请输入节点编号', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.getTableList()
    this.getIncomeSettings()
  },
  methods: {
    async submitFormTwo(){
      let reg = /^\d{0,1}(\.\d{1,8})?$/
      if (!reg.test(this.ruleFormTwo.unitBurn)) {
        this.$message.error('全网平均单T Burn格式不正确或超出8位小数');
        return false
      }
      if (!reg.test(this.ruleFormTwo.unitGas)) {
        this.$message.error('全网平均单T Gas格式不正确或超出8位小数');
        return false
      }
      let data = {
        open: this.ruleFormTwo.open==1?true:false,
        unitGas: this.ruleFormTwo.unitGas,
        unitBurn: this.ruleFormTwo.unitBurn
      }
      let res = await this.$http.updateUnitIncomeSettings({...data});
      if (res) {
        this.$message.success('操作成功！');
        this.dialogVisibleThr = false
        this.getIncomeSettings()
      }
    },
    openSet() {
      let a = this.incomeSettingsData
      this.ruleFormTwo.unitGas = a.unitGas
      this.ruleFormTwo.unitBurn = a.unitBurn
      if (this.incomeSettingsData.open=='true') {
        this.ruleFormTwo.open = 1
      } else {
        this.ruleFormTwo.open = 2
      }
      
      this.dialogVisibleThr = true
    },
    async getIncomeSettings(){
      let res = await this.$http.getUnitIncomeSettings();
      if (res) {
        console.log(res)
        this.incomeSettingsData = res.data
      }
    },
    async ChangeTypeIsDel(row){
      console.log(row)
      let data= {
        minerNodeId: row.minerNodeId,
        isPackage: row.isDelCheck?1:0,
        isSell: row.isSellCheck?1:0,
        autoAllocate: row.isAutoAllocate
      }
      let res = await this.$http.updateNode(data);
      if (res) {
        this.$message.success('操作成功！');
        this.getTableList()
      } 
    },
    ChangeTypeisSell(row){
      console.log(row)
    },
    // 查看详情
    goDetaill(row) {
      this.detaillData = row
      this.dialogVisibleTwo = true
    },
    getCent(row) {
      sessionStorage.setItem("minerCode", row.nodeNumber);
      this.$router.push({ name: 'centsAuditNew'});
    },
    resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    getNumber (num) {
      return num.toFixed(2)
    },
    cancel(row) {
      let _this = this
      sessionStorage.setItem("minerNodeId", row.minerNodeId);
      this.$router.push({ name: 'minercodeDetail'});
    },
    submitForm(formName) {
      let _this = this
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await this.$http.saveOrUpdate({...this.ruleForm});
          if (res) {
            this.$message.success('操作成功！');
            this.dialogVisible=false;
            this.$nextTick(() => {
              this.$refs['ruleForm'].resetFields()
            })
            this.getTableList()
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    addFunc(){
      // this.ruleForm.notes = ''
      // this.ruleForm.nodeNumber = ''
      // this.ruleForm.nodeName = ''
      this.dialogVisible=true;
      this.$nextTick(() => {
        this.$refs['ruleForm'].resetFields()
      })
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.nodeList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list.map(x=>{
              if(x.isPackage==1){
                x.isDelCheck=true
              } else {
                x.isDelCheck=false
              }
              if(x.isSell==1){
                x.isSellCheck=true
              } else {
                x.isSellCheck=false
              }
              if(x.autoAllocate==1){
                x.isAutoAllocate=true
              } else {
                x.isAutoAllocate=false
              }
              return x
          })
          console.log(this.tableData)
          this.totalNum = Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>

<style scoped>
.saml_box{
  margin-bottom: 20px;
}
.decBox{
  margin-top: 20px;
}
.dec_title{
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 20px;
}
.txt_1{
  padding-left: 50px;
}
.txt_2{
  color: #333;
  font-weight: bold;
}
</style>
